import { render } from "./NewExpeditionModal.vue?vue&type=template&id=35b839c7"
import script from "./NewExpeditionModal.vue?vue&type=script&lang=js"
export * from "./NewExpeditionModal.vue?vue&type=script&lang=js"

import "./NewExpeditionModal.vue?vue&type=style&index=0&id=35b839c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__